import { type EditUserInputType } from '@shelflix/schemas/user/edit';
import { create } from 'zustand';

interface UserFormStore {
  formData: Partial<
    EditUserInputType & {
      responsibleUser: {
        uuid: string;
        name: string;
      };
    }
  >;
  setFormData: (
    data: Partial<
      EditUserInputType & {
        responsibleUser: {
          uuid: string;
          name: string;
        };
      }
    >
  ) => void;
  resetForm: () => void;
}

export const useUserFormStore = create<UserFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
